export default class ClearCurrentAgentProfileErrors {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.currentAgent.clearErrors();
  }
}
